import {
  BreakPointCondition,
  RadioTypes,
  UI,
  useBreakpointIf,
  HStack,
  Stack,
  VStack,
} from '@genial/components';
import { BoxBorder, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { InterfaceRadioProps } from 'native-base/lib/typescript/components/primitives/Radio/types';
import React, { useEffect } from 'react';

import { PublicOfferDetailsModalityWithTimelineNormalized } from '../../../../../../../../../../store/product/types';

import { InvestorType, linkedTooltip } from './constants';

export interface ModalitySelectionProps {
  isLoading?: boolean;
  investorType?: InvestorType;
  setInvestorType: (type: InvestorType) => void;
  radioOptions: RadioTypes.Option[];
  modalities: PublicOfferDetailsModalityWithTimelineNormalized[];
  modalitySelected?: string;
  setModalitySelected?: (modality: string) => void;
  modalityDescription?: string;
}

export const ModalitySelection: React.FC<ModalitySelectionProps> = ({
  isLoading,
  investorType,
  setInvestorType,
  radioOptions,
  modalities,
  modalitySelected,
  setModalitySelected,
  modalityDescription,
}) => {
  const isTablet = useBreakpointIf(BreakPointCondition.EqualOrDown, 'lg');

  const isDisabled = false;

  useEffect(() => {
    if (modalities.length === 1) {
      if (setModalitySelected) {
        setModalitySelected(modalities[0].codigoModalidade.toString());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalities]);

  return (
    <VStack space="stack.xxxs">
      <VStack>
        <UI.Tooltip label={linkedTooltip} maxW="400px" openAsAccordionExpanded={isTablet}>
          <HStack alignItems="center" space="inline.nano">
            <UI.Icon name="Info" size="xxxs" color="brand.tertiary.principal" />
            <UI.Text color="neutral.darkest">Tipo de Investidor</UI.Text>
          </HStack>
        </UI.Tooltip>
      </VStack>
      <Stack direction={Utils.Responsive.PhoneTablet({ phone: 'column', tablet: 'row' })}>
        <UI.Radio
          testId="linked-investor-selection"
          options={radioOptions}
          onChange={(value) => setInvestorType(value as InvestorType)}
          selectedValue={investorType || ''}
          textComponentProps={{
            variant: 'semibold',
            color: isDisabled ? 'neutral.medium' : 'neutral.black',
          }}
          radioComponentProps={
            {
              isDisabled,
              padding: 0.5,
              _focus: { borderWidth: '0px', mr: '2px' },
            } as InterfaceRadioProps
          }
          radioGroupComponentProps={{ justifyContent: 'space-between', w: 'full' }}
        />
      </Stack>
      <VStack space="stack.nano">
        <UI.Text variant="semibold">Modalidade</UI.Text>
        <Stack bgColor="background" borderRadius={BoxBorder.thick} w="full">
          <UI.Select
            triggerProps={{
              isDisabled: isLoading,
              _disabled: { opacity: 0.2 },
            }}
            testID="modality-selection"
            options={modalities.map((modality) => ({
              label: modality.modalityName,
              value: `${modality.codigoModalidade}`,
            }))}
            placeholder="Selecione uma opção"
            selectedValue={modalitySelected || ''}
            onValueChange={setModalitySelected}
          />
        </Stack>
      </VStack>
      {!!modalityDescription && (
        <UI.Text color="neutral.dark" fontSize={Typography['fontsize.xs']}>
          {modalityDescription}
        </UI.Text>
      )}
    </VStack>
  );
};
